module.exports = __webpack_public_path__ + "static/media/fosa.0468ec46.png";